
import Component from "vue-class-component";
import {
    EducationalInstitution,
    EducationalQualificationModel,
    EducationalQualificationOptions,
    QualificationActions,
    ResultError
} from "@/api-client";
import {QualificationAddBase} from "@/features/documents/qualifications/views/QualificationAddBase";
import FormLayout from "@/features/personProfile/components/FormLayout.vue";
import FileUploader from "@/components/FileUploader.vue";
import LabelOptional from "@/features/shared/components/LabelOptional.vue";
import CheckboxInput from "@/features/shared/components/CheckboxInput.vue";
import {Prop} from "vue-property-decorator";
import Loader from "@/features/shared/components/Loader";
import toasts from "@/components/Toasts";
import userInfo from "@/features/shared/components/UserInfo";
import Files from "@/components/Files.vue";
import moment from "moment";

@Component({
    components: {
        FileUploader,
        Files,
        FormLayout,
        LabelOptional,
        CheckboxInput
    }
})
export default class EducationalQualificationUpsertForm extends QualificationAddBase<EducationalQualificationModel> {
    @Prop({required: true})
    qualificationPreloadedActions!: QualificationActions;

    @Prop({required: true})
    model!: EducationalQualificationModel;

    @Prop({required: true})
    options!: EducationalQualificationOptions;

    @Prop({required: true})
    submitCallback!: (model: EducationalQualificationModel) => Promise<void>;

    isEducationalInstitutionNameEnteredManually: boolean =
        !this.model.educationalInstitutionId && !!this.model.educationalInstitutionName; // Name is defined but not ID.
    selectedInstitution: EducationalInstitution | null = null;
    validationErrors = ResultError.createEmpty();
    fileLoader = new Loader();
    submitLoader = new Loader();
    isSeafarer = userInfo.seafarerId === this.seafarerId;

    async created() {
        this.$watch(
            () => this.isEducationalInstitutionNameEnteredManually,
            () => {
                if (this.isEducationalInstitutionNameEnteredManually) {
                    this.setSelectedInstitution(null);
                } else {
                    this.options.educationalInstitutions = this.options.educationalInstitutions.filter(e => e.active);
                    this.setSelectedInstitution(this.options.educationalInstitutions[0]);
                }
            }, { immediate: true });
        this.$watch(() => this.model, () => {
            if(this.model.issuedOn && moment().startOf("day").diff(this.model.issuedOn) < 0){
                this.validationErrors.clearKey("issuedOn");
                this.validationErrors.appendMessage(this.$ls.Global_IssuedOn_In_The_Future,"issuedOn");
            }
            else{
                this.validationErrors.clearKey("issuedOn");
            }
            if(this.model.issuedOn && this.model.validUntil){
                if(moment(this.model.validUntil).diff(this.model.issuedOn) <= 0){
                    this.validationErrors.clearKey("validUntil");
                    this.validationErrors.appendMessage(this.$ls.Global_ValidUntil_Before_IssuedOn,"validUntil");
                }
                else{
                    this.validationErrors.clearKey("validUntil");
                }
            }

        },{ deep: true });
    }

    get selectedSpecialityEducation() {
        const speciality = this.options.specialities.find(t => t.id === this.model.specialityId);
        return speciality?.education ?? "";
    }

    setSelectedInstitution(institution: EducationalInstitution | null) {
        this.selectedInstitution = institution;
        this.model.educationalInstitutionId = institution?.id;
    }

    async submit() {
      this.submitLoader.startLoading();
        this.validationErrors.clear();
        await this.submitCallback(this.model)
            .then(async () => {
                toasts.success(this.$ls.Documents_Qualifications_Toast_Success_DocumentSaving);
            })
            .catch(error => this.setValidationErrors(error, this.$ls.Global_Toast_FormSaveFailure));
      this.submitLoader.endLoading();
    }
}
